/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, BrickContext } from 'olympe';
import { getRootTimeoutMap } from '../utils/_helpers';

export default class GetFromRootTimeoutMap extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} key
     * @param {function(): void} forwardEvent
     * @param {function(*): void} setData
     */
    update($, [key], [forwardEvent, setData]) {
        const rootCache = getRootTimeoutMap($);
        setData(rootCache.get(key));
        forwardEvent();
    }
}

registerBrick('018b3870f159c0ca9d34', GetFromRootTimeoutMap);
